const WA_MESSAGE = encodeURIComponent('Olá, fiz uma simulação no site e quero saber mais sobre a restituição do meu consórcio.');
const WA_LINK = `https://wa.me/5511998881316?text=${WA_MESSAGE}`;

export default function CTAWhatsApp() {
  return (
    <>
      {/* Inline CTA Section */}
      <section id="cta-whatsapp" className="py-20 md:py-24 bg-white">
        <div className="max-w-6xl mx-auto px-4 md:px-8">
          <div className="flex flex-col lg:flex-row items-center gap-10 bg-green-50 rounded-3xl p-8 md:p-12 border border-green-100">
            <div className="flex-shrink-0 w-full max-w-xs mx-auto lg:mx-0">
              <img
                src="https://readdy.ai/api/search-image?query=friendly%20professional%20customer%20service%20specialist%20with%20headset%2C%20flat%20illustration%20style%2C%20green%20and%20white%20color%20palette%2C%20modern%20minimalist%20design%2C%20clean%20background%2C%20smiling%20person%20at%20desk%2C%20legal%20financial%20advisor%20concept%2C%20soft%20colors%2C%20no%20text%2C%20vector%20art%20style&width=400&height=400&seq=cta001&orientation=squarish"
                alt="Especialista em consórcio"
                className="w-full h-64 object-cover object-top rounded-2xl"
              />
            </div>
            <div className="flex-1 text-center lg:text-left">
              <span className="inline-block bg-green-100 text-green-700 text-sm font-semibold px-4 py-1.5 rounded-full mb-4">
                Atendimento Especializado
              </span>
              <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4">
                Dúvidas? Fale Direto com<br className="hidden md:block" /> Nosso Time de Especialistas
              </h2>
              <p className="text-gray-500 text-base mb-6 leading-relaxed">
                Nossa equipe jurídica está pronta para analisar o seu caso gratuitamente e
                orientar sobre as melhores estratégias para recuperar seus valores.
              </p>
              <a
                href={WA_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 bg-green-500 hover:bg-green-600 text-white font-bold px-8 py-4 rounded-full text-base transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                Iniciar Conversa no WhatsApp
              </a>
              <p className="text-gray-400 text-sm mt-3">
                <i className="ri-time-line mr-1"></i>
                Seg–Sex: 8h às 18h &nbsp;|&nbsp; Sáb: 9h às 13h
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Floating WhatsApp Button */}
      <a
        href={WA_LINK}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 group cursor-pointer"
        aria-label="Fale com especialista no WhatsApp"
      >
        <div className="relative w-16 h-16 flex items-center justify-center bg-green-500 hover:bg-green-600 rounded-full shadow-lg shadow-green-500/40 transition-all duration-300 hover:scale-110">
          <i className="ri-whatsapp-line text-white text-3xl"></i>
          <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full animate-ping"></span>
          <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full"></span>
        </div>
        <div className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-gray-900 text-white text-xs font-medium px-3 py-1.5 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          Fale com Especialista
        </div>
      </a>
    </>
  );
}
